import React, { useState, useEffect, useRef } from 'react';
import ReportButton from './ReportButton';

export default function ChatPanel({ socket, roomPlayers }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [muteError, setMuteError] = useState('');
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (!socket) return;
    const onChat = (msg) => {
      setMessages(prev => [...prev, msg]);
    };
    const onChatError = ({ message }) => {
      setMuteError(message);
      setTimeout(() => setMuteError(''), 4000);
    };
    socket.on('chat-message', onChat);
    socket.on('chat-error', onChatError);
    return () => {
      socket.off('chat-message', onChat);
      socket.off('chat-error', onChatError);
    };
  }, [socket]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (!input.trim() || !socket) return;
    socket.emit('chat-message', { text: input.trim() });
    setInput('');
  };

  // Build a nickname -> userId map from roomPlayers
  const nicknameToUserId = {};
  if (roomPlayers) {
    roomPlayers.forEach(p => {
      if (p.nickname && p.userId) nicknameToUserId[p.nickname] = p.userId;
    });
  }

  return (
    <>
      {/* Header */}
      <div style={{
        padding: '8px 10px', borderBottom: '1px solid #30363d',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        flexShrink: 0
      }}>
        <span style={{ color: '#e2e8f0', fontSize: 12, fontWeight: 700 }}>Chat</span>
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '6px 10px', minHeight: 0 }}>
        {messages.length === 0 && (
          <div style={{ color: '#4b5563', fontSize: 11, textAlign: 'center', paddingTop: 12 }}>
            No messages yet
          </div>
        )}
        {messages.map((msg, i) => {
          const userId = nicknameToUserId[msg.nickname];
          return (
            <div key={i} style={{ marginBottom: 6 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span style={{ color: '#58a6ff', fontSize: 11, fontWeight: 600 }}>{msg.nickname}</span>
                <span style={{ color: '#4b5563', fontSize: 9 }}>
                  {new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
                {userId && (
                  <ReportButton reportedUserId={userId} reportedNickname={msg.nickname} size="sm" />
                )}
              </div>
              <div style={{ color: '#c9d1d9', fontSize: 12, marginTop: 1 }}>{msg.text}</div>
            </div>
          );
        })}
        <div ref={messagesEndRef} />
      </div>

      {/* Mute error */}
      {muteError && (
        <div style={{
          padding: '6px 10px', background: '#3d1f1f', color: '#f85149',
          fontSize: 11, textAlign: 'center'
        }}>
          {muteError}
        </div>
      )}

      {/* Input */}
      <form onSubmit={sendMessage} style={{
        padding: '6px 8px', paddingBottom: 'calc(6px + env(safe-area-inset-bottom, 0px))',
        borderTop: '1px solid #30363d',
        display: 'flex', gap: 4, flexShrink: 0
      }}>
        <input
          type="text"
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="Type a message..."
          style={{
            flex: 1, background: '#0d1117', border: '1px solid #30363d',
            borderRadius: 6, padding: '5px 8px', color: '#e2e8f0', fontSize: 12,
            outline: 'none'
          }}
        />
        <button type="submit" style={{
          background: '#238636', color: '#fff', border: 'none', borderRadius: 6,
          padding: '5px 10px', fontSize: 11, cursor: 'pointer'
        }}>Send</button>
      </form>
    </>
  );
}
